document.addEventListener("DOMContentLoaded", function () {

  let bundleItems = [];

  function getTotalQty() {
    return bundleItems.reduce((sum, item) => sum + item.qty, 0);
  }

  document.addEventListener('click', function(e) {

    const btn = e.target.closest('.bundle-card-pro-btn');

    // ➕ ADD ITEM
    if (btn) {
      e.preventDefault();

      if (getTotalQty() >= 3) return;

      const id = btn.dataset.bundleId;
      const existing = bundleItems.find(i => i.id === id);

      if (existing) {
        existing.qty++;
      } else {
        bundleItems.push({
          id: id,
          title: btn.dataset.title,
          price: parseFloat(btn.dataset.price.replace(/[^\d.]/g, '')),
          comPrice: btn.dataset.com_price ? parseFloat(btn.dataset.com_price.replace(/[^\d.]/g, '')) : null,
          image: btn.dataset.image,
          info: btn.dataset.add_info || '',
          qty: 1
        });
      }

      renderBundle();
      toggleButtons();
      toggleButtonsBundle();

      if (getTotalQty() === 3) openBundlePopup();
    }

    // ➕ PLUS button on quantity selector
    const plusBtn = e.target.closest('.bundle-qty-plus');
    if (plusBtn) {
      const id = plusBtn.dataset.id;
      const item = bundleItems.find(i => i.id === id);
      if (item && getTotalQty() < 3) {
        item.qty++;
        renderBundle();
        toggleButtons();
        toggleButtonsBundle();

        if (getTotalQty() === 3) openBundlePopup();
      }
    }

    // ➖ MINUS button on quantity selector
    const minusBtn = e.target.closest('.bundle-qty-minus');
    if (minusBtn) {
      const id = minusBtn.dataset.id;
      const item = bundleItems.find(i => i.id === id);
      if (item) {
        item.qty--;
        if (item.qty <= 0) {
          bundleItems = bundleItems.filter(i => i.id !== id);
        }
        renderBundle();
        toggleButtons();
        toggleButtonsBundle();
      }
    }

    // ❌ REMOVE ITEM from sidebar (decrement one unit per slot)
    const removeBtn = e.target.closest('.bundle-remove-btn');
    if (removeBtn) {
      const id = removeBtn.dataset.id;
      const item = bundleItems.find(i => i.id === id);
      if (item) {
        item.qty--;
        if (item.qty <= 0) {
          bundleItems = bundleItems.filter(i => i.id !== id);
        }
      }
      renderBundle();
      toggleButtons();
      toggleButtonsBundle();
    }

  });

  function renderBundle() {
    const slots = document.querySelectorAll('.bundle-col-sidebar-inner .bundle-item');
    const countEl = document.querySelector('.bundle-col-sidebar-title span');
    const totalEl = document.querySelector('.bundle-col-sidebar-total');
    const totalQty = getTotalQty();

    // Expand each bundle item into one slot per unit of qty
    const slotItems = [];
    bundleItems.forEach(item => {
      for (let i = 0; i < item.qty; i++) slotItems.push(item);
    });

    slots.forEach((slot, index) => {
      const item = slotItems[index];

      if (item) {
        slot.setAttribute('data-price', item.price);
        slot.querySelector('.bundle-item-image img').src = item.image;
        slot.querySelector('.bundle-item-image img').width = 80;
        slot.querySelector('h4').textContent = item.title;
        slot.querySelector('span').textContent = item.info;

        // Add remove button if not already there
        if (!slot.querySelector('.bundle-remove-btn')) {
          const btn = document.createElement('button');
          btn.className = 'bundle-remove-btn';
          btn.textContent = '✕';
          slot.prepend(btn);
        }
        slot.querySelector('.bundle-remove-btn').dataset.id = item.id;

        slot.classList.add('bundle-item--active');
      } else {
        // Clear empty slot
        slot.removeAttribute('data-price');
        slot.querySelector('.bundle-item-image img').src = '';
        slot.querySelector('h4').textContent = '';
        slot.querySelector('span').textContent = '';

        const removeBtn = slot.querySelector('.bundle-remove-btn');
        if (removeBtn) removeBtn.remove();

        slot.classList.remove('bundle-item--active');
      }
    });

    if (countEl) {
      countEl.textContent = totalQty;
      const before = countEl.previousSibling;
      if (before && before.nodeType === 3) {
        before.textContent = totalQty >= 3 ? 'הערכה שלך מוכנה (' : 'הערכה שלך (';
      }
    }

    // ✅ total
    const total = bundleItems.reduce((sum, item) => sum + (item.price * item.qty), 0);
    // compare price total (use compare price when available, otherwise regular price)
    const compareTotal = bundleItems.reduce((sum, item) => sum + ((item.comPrice || item.price) * item.qty), 0);

    // Bundle discount (section settings > Bundle discount). Display only: the
    // real discount must exist in Shopify / the discount app.
    const wrapper = document.querySelector('.bundle-col-sidebar-wrapper');
    const discountPercent = wrapper ? parseFloat(wrapper.dataset.discountPercent) || 0 : 0;
    const discountMinItems = wrapper ? parseInt(wrapper.dataset.discountMinItems, 10) || 3 : 3;
    const discountActive = discountPercent > 0 && totalQty >= discountMinItems && total > 0;
    const finalTotal = discountActive ? total * (1 - discountPercent / 100) : total;
    const formatPrice = (value) => '₪' + (Math.round(value * 100) / 100);

    if (totalEl) {
      totalEl.childNodes[0].textContent = `${formatPrice(finalTotal)} `;
      totalEl.classList.toggle('discount-avail', discountActive);
    }

    const badgeEl = document.querySelector('.bundle-col-discount-badge');
    if (badgeEl) badgeEl.hidden = !discountActive;

    const compareEl = document.querySelector('.bundle-col-compare');
    if (compareEl) {
      if (compareTotal > finalTotal) {
        compareEl.textContent = formatPrice(compareTotal);
        compareEl.style.display = '';
        totalEl.classList.add('compare-avail');
      } else {
        compareEl.textContent = '';
        compareEl.style.display = 'none';
        totalEl.classList.remove('compare-avail');
      }
    }

  }

  function toggleButtons() {
    const buttons = document.querySelectorAll('.bundle-card-pro-btn');
    const totalQty = getTotalQty();

    buttons.forEach(btn => {
      const id = btn.dataset.bundleId;
      const item = bundleItems.find(i => i.id === id);
      let qtySelector = btn.parentElement.querySelector('.bundle-qty-selector');

      if (item) {
        // Hide button, show quantity selector
        btn.style.display = 'none';

        if (!qtySelector) {
          qtySelector = document.createElement('div');
          qtySelector.className = 'bundle-qty-selector';
          qtySelector.innerHTML = `
            <button class="bundle-qty-btn bundle-qty-minus" data-id="${id}">
            <svg width="10" height="1" viewBox="0 0 10 1" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M0 0.5H10" stroke="black"/></svg>
            </button>
            <span class="bundle-qty-value">${item.qty}</span>
            <button class="bundle-qty-btn bundle-qty-plus" data-id="${id}">
            <svg width="10" height="11" viewBox="0 0 10 11" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M5.5 4.55859H10V5.55859H5.5V10.1152H4.5V5.55859H0V4.55859H4.5V0H5.5V4.55859Z" fill="black"/></svg>
            </button>
          `;
          btn.parentElement.appendChild(qtySelector);
        } else {
          qtySelector.querySelector('.bundle-qty-value').textContent = item.qty;
        }

        // Disable plus if total qty reached 3
        const plus = qtySelector.querySelector('.bundle-qty-plus');
        if (totalQty >= 3) {
          plus.setAttribute('disabled', 'true');
        } else {
          plus.removeAttribute('disabled');
        }

      } else {
        // Show button, remove quantity selector
        if (totalQty >= 3) {
          btn.style.display = 'inline-flex';
          btn.style.pointerEvents = 'none';
          btn.style.opacity = '0.5';
        } else {
          btn.style.display = 'inline-flex';
          btn.style.pointerEvents = 'auto';
          btn.style.opacity = '1';
        }

        if (qtySelector) qtySelector.remove();
      }
    });
  }

  function showBundleError(message) {
    document.querySelector('.bundle-confirm-overlay.bundle-error')?.remove();

    const overlay = document.createElement('div');
    overlay.className = 'bundle-confirm-overlay bundle-error';
    overlay.innerHTML = `
      <div class="bundle-confirm-popup" role="alertdialog" aria-modal="true">
        <p class="bundle-confirm-message">${message}</p>
        <div class="bundle-confirm-actions">
          <button type="button" class="bundle-confirm-close button button--primary">סגור</button>
        </div>
      </div>
    `;
    document.body.appendChild(overlay);
    requestAnimationFrame(() => overlay.classList.add('active'));

    const close = () => {
      overlay.classList.remove('active');
      setTimeout(() => overlay.remove(), 200);
    };
    overlay.querySelector('.bundle-confirm-close').addEventListener('click', close);
    overlay.addEventListener('click', (e) => { if (e.target === overlay) close(); });
  }

  function toggleButtonsBundle() {
    const sidebarBtn = document.querySelector('.bundle-col-sidebar-btn');

    if (!sidebarBtn) return;

    if (getTotalQty() === 3) {
      sidebarBtn.removeAttribute('disabled');
    } else {
      sidebarBtn.setAttribute('disabled', 'true');
    }
  }

  function openBundlePopup() {
    const sidebar = document.querySelector('.bundle-col-sidebar');
    if (!sidebar || sidebar.classList.contains('active-popup')) return;

    let overlay = document.querySelector('.custom-overlay');
    if (!overlay) {
      overlay = document.createElement('div');
      overlay.className = 'custom-overlay';
      document.body.appendChild(overlay);
    }

    sidebar.classList.add('active-popup');
    overlay.classList.add('active');

    if (window.matchMedia('(max-width: 749px)').matches) {
      document.body.classList.add('overflow-hidden');
    }
  }

  function closeBundlePopup() {
    const sidebar = document.querySelector('.bundle-col-sidebar');
    const overlay = document.querySelector('.custom-overlay');

    sidebar?.classList.remove('active-popup');
    overlay?.classList.remove('active');
    document.body.classList.remove('overflow-hidden');
  }


      // add to cart bundle
      document.addEventListener('click', function(e) {

        const addBundleBtn = e.target.closest('.bundle-col-sidebar-btn');
        if (!addBundleBtn) return;

        e.preventDefault();

        if (getTotalQty() !== 3) return;

        closeBundlePopup();

        const bundleId = 'BUNDLE_' + Date.now();

        fetch('/cart/add.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
          body: JSON.stringify({
            items: bundleItems.map(item => ({
              id: parseInt(item.id, 10),
              quantity: item.qty,
              properties: {
                _bundle_id: bundleId
              }
            }))
          })
        })
          .then(async res => {
            if (!res.ok) {
              const errBody = await res.json().catch(() => ({}));
              console.error('Cart add error response:', errBody);
              throw new Error(errBody.description || errBody.message || 'Failed to add items');
            }
            return res.json();
          })
          .then(() => {
            return fetch(`${routes.cart_url}?sections=cart-drawer,cart-icon-bubble`);
          })
          .then(res => res.json())
          .then(sections => {
            const cartDrawer = document.querySelector('cart-drawer');
            if (!cartDrawer) return;

            // Update cart drawer HTML
            const drawerEl = document.querySelector('#CartDrawer');
            if (drawerEl && sections['cart-drawer']) {
              drawerEl.innerHTML = new DOMParser()
                .parseFromString(sections['cart-drawer'], 'text/html')
                .querySelector('#CartDrawer').innerHTML;
            }

            // Update cart icon bubble count
            const iconEl = document.getElementById('cart-icon-bubble');
            if (iconEl && sections['cart-icon-bubble']) {
              iconEl.innerHTML = new DOMParser()
                .parseFromString(sections['cart-icon-bubble'], 'text/html')
                .querySelector('.shopify-section').innerHTML;
            }

            // Re-bind overlay close and open drawer
            cartDrawer.querySelector('#CartDrawer-Overlay')?.addEventListener('click', cartDrawer.close.bind(cartDrawer));
            cartDrawer.classList.remove('is-empty');
            cartDrawer.classList.add('animate', 'active');
            document.body.classList.add('overflow-hidden');
          })
          .catch(err => {
            console.error('Bundle add failed:', err);
            showBundleError(err.message || 'אירעה שגיאה בהוספת החבילה לעגלה');
          });

      });

      document.addEventListener('click', function (e) {
      const header = e.target.closest('.bundle-col-sidebar-header');
      const removeBtn = e.target.closest('.bundle-remove-btn');
      const sidebar = document.querySelector('.bundle-col-sidebar');

      if (!sidebar) return;

      // Don't close popup when removing an item — renderBundle() may detach
      // the clicked button, making e.target.closest('.bundle-col-sidebar')
      // return null and falsely trigger the outside-click branch below.
      if (removeBtn) return;

      // Create overlay once
      let overlay = document.querySelector('.custom-overlay');
      if (!overlay) {
        overlay = document.createElement('div');
        overlay.className = 'custom-overlay';
        document.body.appendChild(overlay);
      }

      const isMobile = window.matchMedia('(max-width: 749px)').matches;

      // 🔁 TOGGLE only on header click
      if (header) {
        const isActive = sidebar.classList.contains('active-popup');

        sidebar.classList.toggle('active-popup');
        overlay.classList.toggle('active');

        if (isMobile) {
          if (!isActive) {
            document.body.classList.add('overflow-hidden');
          } else {
            document.body.classList.remove('overflow-hidden');
          }
        }

        return;
      }

      // ❌ CLOSE on overlay click OR outside
      // Bundle add/qty controls live outside the sidebar — don't treat them as
      // outside clicks, otherwise the auto-open on the 3rd selection would be
      // immediately closed by the same click event.
      const bundleControl = e.target.closest('.bundle-card-pro-btn, .bundle-qty-selector');
      if (
        e.target.classList.contains('custom-overlay') ||
        (!e.target.closest('.bundle-col-sidebar') && !bundleControl)
      ) {
        sidebar.classList.remove('active-popup');
        overlay.classList.remove('active');
        document.body.classList.remove('overflow-hidden');
      }
    });

});
